import React from 'react';
import { BookOpenIcon, CheckIcon, InfoIcon, TargetIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionHeading } from '../SectionHeading';
import { volumes } from '../../data/volumes';
export function Volumes() {
  return <section className="bg-navy-950 px-5 py-16 sm:py-20" aria-label="What's inside" data-id="element-363" data-mp="2x3cs3ja115os">
      <div className="mx-auto max-w-6xl" data-id="element-364" data-mp="2szey1mzk6l2l">
        <SectionHeading tone="dark" kicker="What’s inside Maxillary Growth Blueprint™?" title="Your complete 6-volume clinical collection" subtitle="Six specialized digital volumes organized around the essential stages of maxillary growth assessment and orthopedic planning." data-id="element-365" data-mp="2o13lv5lsjyh7" />

        <div className="mt-12 grid gap-5 lg:grid-cols-2" data-id="element-366" data-mp="29cqqa9qm8hn8">
          {volumes.map(volume => <article key={volume.number} className="flex flex-col rounded-3xl bg-white p-6 sm:p-8" data-id="element-367" data-mp="2592f7h2rz3x8">
              <div className="flex items-center gap-3" data-id="element-368" data-mp="20c2bvdxb8f9t">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-electric text-white" data-id="element-369" data-mp="335mg1eeygro7">
                  <BookOpenIcon className="h-6 w-6" aria-hidden="true" data-id="element-370" data-mp="37wmbef8ff1ol" />
                </span>
                <span className="rounded-full bg-gold px-3 py-1 font-display text-sm font-black uppercase text-navy-950" data-id="element-371" data-mp="2u5hh7sntv1ln">
                  Volume {volume.number}
                </span>
              </div>
              <h3 className="mt-5 font-display text-2xl font-black uppercase leading-tight text-navy-950" data-id="element-372" data-mp="3lvvq1agzhnqg">
                {volume.title}
              </h3>
              <p className="mt-2 font-semibold leading-snug text-electric" data-id="element-373" data-mp="3qsuk5t0nduon">{volume.subtitle}</p>
              <p className="mt-3 text-[15px] leading-relaxed text-ink/75" data-id="element-374" data-mp="3cxjuqv56a1ro">{volume.intro}</p>

              <ul className="mt-5 space-y-2.5" data-id="element-375" data-mp="3hwmz0ddbw3yl">
                {volume.topics.map(topic => <li key={topic} className="flex gap-2.5 text-[15px] leading-snug text-ink" data-id="element-376" data-mp="21id8pdpj0554">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-377" data-mp="26gog7hscm3k6" />
                    {topic}
                  </li>)}
              </ul>

              {volume.note && <p className="mt-4 flex gap-2 text-xs leading-snug text-ink/60" data-id="element-378" data-mp="293msqpvmkrr">
                  <InfoIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-379" data-mp="3ud4fnc5g2ma4" />
                  {volume.note}
                </p>}

              <div className="mt-auto pt-6" data-id="element-380" data-mp="3pf2v0msdeewj">
                <div className="flex gap-3 rounded-2xl bg-mist p-4" data-id="element-381" data-mp="3pbouzl76ihs9">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-navy-800" aria-hidden="true" data-id="element-382" data-mp="3kddljbksq9ak" />
                  <p className="text-[15px] leading-snug text-ink" data-id="element-383" data-mp="3fgdnnny3ocuj">
                    <strong className="text-navy-950" data-id="element-384" data-mp="3bf1z7lqypxnx">Your takeaway:</strong> {volume.takeaway}
                  </p>
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12" data-id="element-385" data-mp="19nyl2mhv60ym">
          <CtaButton label="I want all 6 volumes now" caption="Instant digital access · One-time payment of $27" tone="dark" data-id="element-386" data-mp="19noryq1ivdop" />
        </div>
      </div>
    </section>;
}